import {
  CompanyAttributes,
  MastersUser,
  StatusEnum,
  TripAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import { Component, OnDestroy, TemplateRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  NgModel,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { NgSelectModule } from "@ng-select/ng-select";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { RouteGroupService } from "../../routing/route-group/route-group.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { OfficeGroupService } from "../../configuration/office-group/office-group.service";
import { BusinessPartnerService } from "../../business-partners/business-partner/business-partner.service";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import OfficeGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/office-group/office-group.entity";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatInputModule } from "@angular/material/input";
import { TripRouteService } from "./trip.service";
import { filter, firstValueFrom, map, Observable, skip, Subscription } from "rxjs";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatBadgeModule } from "@angular/material/badge";
import { ICreateTrip } from "./interfaces/createTrip";
import { VechicleService } from "../../transport/vechicle/vehicle.service";
import VehicleAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle/vehicle.entity";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatMenuModule } from "@angular/material/menu";
// IUpdateTrip ahora se usa solo en SharedTripEditModalComponent
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import { IRequestResult } from "app/common/interfaces";
import { DayTableModel } from "@fullcalendar/core/internal";
import { UserMasterService } from "../../routing/sub-routes/sub-route-collaborator/user_master.service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { getCode } from "app/utils/method";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { format } from "date-fns";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DateHelper } from "app/utils/date.helper";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { TripStatusBadgeComponent } from "app/shared/components/trip-status-badge/trip-status-badge.component";
import { SharedTripEditModalComponent } from "app/modules/shared/components/shared-trip-edit-modal/shared-trip-edit-modal.component";
import { TRIP_STATUS_LIST, TripStatus } from "app/common/enums/trip-status.enum";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { AuditLogViewerService } from 'app/shared/services/audit-log-viewer.service';
import { AUDIT_LOG_COLLECTIONS } from 'app/shared/components/audit-log-viewer/audit-log-collections.constants';
import { PermissionDirective } from "app/core/permission";
import { SALES_MONITOR_PERMISSIONS } from "app/common/constants/permission";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { FlatTreeControl } from "@angular/cdk/tree";
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree";
import { UnifiedLoadDocsChipComponent } from "app/shared/components/unified-load-docs-chip/unified-load-docs-chip.component";

//Interface Node
interface TripTreeNode extends Partial<TripAttributes> {
  level: number;
  expandable: boolean;
  children?: TripTreeNode[];
  treeNodeId?: string;
  statusInfo?: {
    id: StatusEnum;
    color: string;
    info: string;
    icon: string;
  };
  functionInfo?: {
    id: string;
    name: string;
    code: string;
  };
  isStatusGroup?: boolean;
  isFunctionGroup?: boolean;
  status?: string;
  businessPartner?: {
    code?: string;
    name?: string;
  };
  groupId?: string; //  identificar grupos

}

@Component({
  selector: "app-trip",
  standalone: true,
  imports: [
    UnifiedLoadDocsChipComponent,
    CommonModule,
    MatTableModule,
    MatSidenavContainer,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    FormsModule,
    MatDatepickerModule,
    NgSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatSelectModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
    MatBadgeModule,
    MatDialogModule,
    NgSelectModule,
    MatMenuModule,
    NgxMaterialTimepickerModule,
    FilterComponent,
    FilterSectionComponent,
    DatesFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    ConfigurationFiltersComponent,
    FormSectionComponent,
    UserRouteDisplayComponent,
    TripStatusBadgeComponent,
    HoverMenuDirective,
    StatusFiltersComponent,
    PermissionDirective
  ],
  templateUrl: "./trip.component.html",
  styleUrl: "./trip.component.scss",
})
export class TripComponent implements OnDestroy {
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  getCode = getCode;
  TripStatus = TripStatus;
  readonly PERMISSIONS = SALES_MONITOR_PERMISSIONS;

  // Paginacion
  pageSize: number = 50;
  pageIndex: number = 0;
  totalItems: number;

  // Datos Filter
  isAcive: boolean = true;
  submitted: boolean = false;
  form: FormGroup<any>;
  materilaList: any = {};
  companyList: CompanyAttributes[] = [];
  materialList: any = [];
  routeList: RouteAttributes[] = [];
  routeListGeneral: RouteAttributes[] = [];
  vechicleListGeneral: VehicleAttributes[] = [];
  routeGroupList: RouteGroupAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  officeGroupList: OfficeGroupAttributes[] = [];
  businessPartnerList: BusinessPartnerAttributes[] = [];
  isLoadingTreedata = false;

  dialogRefAdd: MatDialogRef<any>;
  dialogReEdit: MatDialogRef<any>;
  statusList = [];
  userMasterList: any[] = [];

  dataSourceTrip: MatTableDataSource<TripAttributes>;
  selectedTripStatuses: number[] = [];
  selectedRouteFunction: string[] = [];
  displayColumsTree: string[] = [
    "det", "travel", "routeUser", "start", "end", "dateChare", "vehicle", "state", "actions"
  ];

  modeTreeTrip: "statusTrip" | "functionTrip" | null = null;
  tripStatusOptions = [
    { id: TripStatus.ABIERTO, name: 'Abierto', code: 'TRIP_CREATED' },
    { id: TripStatus.CARGANDO, name: 'Cargando', code: 'TRIP_READY_TO_START' },
    { id: TripStatus.EN_PROCESO, name: 'En proceso', code: 'TRIP_IN_PROCESS' },
    { id: TripStatus.CERRADO, name: 'Cerrado', code: 'TRIP_CLOSED' },
    { id: TripStatus.LIQUIDANDO, name: 'Liquidando', code: 'TRIP_IN_LIQUIDATION' },
    { id: TripStatus.DOC_LIQUIDACION_CREADO, name: 'Doc. liquidación creado', code: 'TRIP_LIQUIDATION_DOC_CREATED' },
    { id: TripStatus.DOC_LIQUIDACION_APROBADO, name: 'Doc. liquidación aprobado', code: 'TRIP_LIQUIDATION_DOC_APPROVED' },
    { id: TripStatus.FINALIZADO, name: 'Finalizado', code: 'TRIP_FINALIZED' },
  ];
  routeFunctionOptions = [
    { code: '07', name: 'PREVENTA' },
    { code: '08', name: 'ENTREGA' }
  ];
  private transformer = (node: TripTreeNode, level: number): TripTreeNode => {
    return {
      ...node,
      expandable: !!(node.children && node.children.length > 0),
      level: level,
    };
  };
  treeControl = new FlatTreeControl<TripTreeNode>(
    node => node?.level || 0,
    node => node?.expandable || false,
  );

  treeFlattener = new MatTreeFlattener<TripTreeNode, TripTreeNode>(
    this.transformer,
    node => node?.level || 0,
    node => node?.expandable || false,
    node => node?.children || [],
  );
  dataSourceTreeTrip = new MatTreeFlatDataSource<TripTreeNode, TripTreeNode>(this.treeControl, this.treeFlattener);
  hasChild = (_: number, node: TripTreeNode): boolean => {
    return node?.expandable || false;
  };
  getLevel = (node: TripTreeNode): number => {
    return node?.level || 0;
  };
  public displayColums: string[] = [
    "travel",
    //"status",
    "routeUser",
    // "businessPartner",
    "start",
    "end",
    "dateChare",
    "vehicle",
    "state",
    "hasUnifiedLoadDocs",
    "actions",
  ];
  searchMaterialGroup = "";
  routeFilterList: any[] = [];
  userMasterFilterList: any[] = [];
  // Crear viaje
  currentCreateTrip: ICreateTrip = this.initializeCreateTrip();

  minDate: Date;
  minDateEnd: Date;

  //BUSCADOR
  searchSubscription: Subscription;

  // Query params
  tripsToFilter: number[] = [];

  constructor(
    private readonly userMasterService: UserMasterService,
    private readonly tripService: TripRouteService,
    private readonly routeService: SubRouteService,
    private readonly routeGroupService: RouteGroupService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly officeGroupService: OfficeGroupService,
    private readonly bussinesPartnerService: BusinessPartnerService,
    private readonly vehicleService: VechicleService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private readonly router: Router,
    private readonly searchService: SearchService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly auditLogViewerService: AuditLogViewerService,
  ) {
    this.minDate = new Date();
    this.form = this.fb.group({
      companyId: [null],
      startTrip: [this.minDate],
      endTrip: [this.minDate],
      end_startTrip: [],
      end_endTrip: [],
      charge_start: [],
      charge_end: [],
      salesOfficeGroupId: [[]],
      assignedUserId: [],
      salesOfficeId: [[]],
      routeGroupId: [[]],
      subRouteId: [[]],
      searchAssignedUser: [],
      routeTypeId: [],
      hasUnifiedLoadDocs: [null],
    });
  }

  ngOnInit() {
    this.onHandleSearch();

    this.pageIndex += 1;

    // Leer query params desde la URL
    const queryParams = this.activatedRoute.snapshot.queryParams;
    if (queryParams && queryParams['tripId']) {
      const tripIdParam = queryParams['tripId'];
      // Puede venir como "123,456" o "123"
      this.tripsToFilter = tripIdParam
        .split(',')
        .map((id: string) => parseInt(id.trim(), 10))
        .filter((id: number) => !isNaN(id));
    }

    this.fetchAllWithCount();
    this.fetchAllRouteToCreate();
    // this.fetchAllRoute();
    this.statusTrip();
    this.fetchAllVehicleToCreate();
    // this.fetchGroupRutes();
    // this.fetchOfficeGroup();
    this.fetchAllUserMaster();
  }

  changueOptionsGroupMaterial(event) {
    let search = event;
    if (!search) {
      this.routeList = this.routeFilterList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.routeList = this.routeFilterList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  changueOptionsUser(event) {
    let search = event;
    if (!search) {
      this.userMasterList = this.userMasterFilterList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.userMasterList = this.userMasterFilterList.filter(
      (item) =>
        // item.businessPartnerName.toLowerCase().indexOf(search) > -1 ||
        item.user_login_username.toLowerCase().indexOf(search) > -1
    );
  }

  private async fetchAllUserMaster(search?): Promise<void> {
    try {
      const filter = {
        search: search,
      };
      const resUser: any = await firstValueFrom(
        this.userMasterService.findUserAvailable(filter)
      );
      this.userMasterList = resUser.data;
      this.userMasterFilterList = resUser.data.slice();
    } catch (err) {
      this.snackBar.open(err.error.message || "Error al obtener vendedores.", "Cerrar", { duration: 5000 });
    }
  }

  private initializeCreateTrip(): ICreateTrip {
    return {
      description: null,
      loadDateTime: null,
      dateHourStartTeoric: null,
      time: null,
      dateHourEndTeoric: null,
      subRouteId: null,
    };
  }

  getGroupColor(node: TripTreeNode): string {
    if (node.statusInfo) {
      return node.statusInfo.color;
    }
    if (node.functionInfo) {
      return 'bg-blue-500';
    }
    return 'bg-gray-300';
  }

  onTimeSet(timeInput: NgModel) {
    timeInput.control.markAsTouched();
    timeInput.control.updateValueAndValidity();
  }
  getGroupName(node: TripTreeNode): string {
    if (this.modeTreeTrip === 'statusTrip' && node.statusInfo) {
      return node.statusInfo.info.toUpperCase();
    }
    if (this.modeTreeTrip === 'functionTrip' && node.functionInfo) {
      return node.functionInfo.name;
    }
    return ' ';
  }

  openCreateModal(): void {
    this.currentCreateTrip = this.initializeCreateTrip();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
  }

  openEditModal(item): void {
    this.dialogReEdit = this.dialog.open(SharedTripEditModalComponent, {
      width: '800px',
      maxWidth: '90vw',
      panelClass: "form-modal-update",
      disableClose: true,
      data: { tripId: item._id }
    });

    this.dialogReEdit
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.fetchAllWithCount();
        }
      });
  }

  get isValidateFormCreate() {
    return (
      this.currentCreateTrip.loadDateTime !== null &&
      this.currentCreateTrip.dateHourStartTeoric !== null &&
      this.currentCreateTrip.dateHourEndTeoric !== null &&
      this.currentCreateTrip.subRouteId !== null &&
      this.currentCreateTrip.time !== null
    );
  }

  public onChangeCreateStarTrip(event) {
    this.minDateEnd = this.currentCreateTrip.dateHourStartTeoric;
    if (
      this.currentCreateTrip?.dateHourEndTeoric <
      this.currentCreateTrip.dateHourStartTeoric
    ) {
      this.currentCreateTrip.dateHourEndTeoric = null;
    }
  }

  public onChangeCreateStarEnd() {
    this.minDate = this.currentCreateTrip.dateHourEndTeoric;
  }

  // Métodos de edición eliminados - ahora manejados por SharedTripEditModalComponent

  public onPageChange(event) {
    this.pageIndex = event.pageIndex + 1;
    this.fetchAllWithCount();
  }

  // Buscado

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
    .pipe(
      skip(1)
    )
    .subscribe(
      (term) => {
        this.fetchAllWithCount();
      }
    );
  }

  // Obtencion de los datos del Filtro

  // Limpiar Filtro
  public handleFilterClean() {
    const today = new Date();
    this.form.reset({
      startTrip: null,
      endTrip: null,
      end_startTrip: null,
      end_endTrip: null,
      charge_start: null,
      charge_end: null,
      salesOfficeGroupId: [[]],
      assignedUserId: [],
      salesOfficeId: [[]],
      routeGroupId: [[]],
      subrouteId: [[]],
      searchAssignedUser: [],
      hasUnifiedLoadDocs: null,
    });
    this.dataSourceTrip.data = [];
    //limpiar los nuevos filtros  
    this.selectedTripStatuses = [];
    this.selectedRouteFunction = [];
    this.modeTreeTrip = null;

  }

  public compareById = (o1: any, o2: any) => o1 && o2 && o1._id === o2._id;

  public onSelectionChangeSalesGroup(): void {
    this.fetchAllSalesOffice();
  }

  public onSelectionChangeGroupRoutes(): void {
    this.fetchAllRoute();
  }

  // Fetch Rutas
  private fetchAllRoute(): void {
    this.routeService
      .findToComboBoxByGroup(this.form.value.routeGroupId)
      .subscribe({
        next: (res) => {
          this.routeList = res.data;
          this.routeFilterList = res.data.slice();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener rutas.", "Cerrar", { duration: 5000 });
        },
      });
  }

  // Fetch All Rutas
  private fetchAllRouteToCreate(): void {
    this.routeService.findToComboBox().subscribe({
      next: (res) => {
        const data = res.data;
        this.routeListGeneral = data.filter((item) => item.mainCollaborator);
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener rutas.", "Cerrar", { duration: 5000 });
      },
    });
  }

  // Fetch All Vehicle
  private fetchAllVehicleToCreate(): void {
    this.vehicleService.findToComboBox().subscribe({
      next: (res) => {
        this.vechicleListGeneral = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener vehículos.", "Cerrar", { duration: 5000 });
      },
    });
  }

  // Fetch Rutas

  private fetchGroupRutes(): void {
    this.routeGroupService.findToComboBox().subscribe((res) => {
      this.routeGroupList = res.data;
    });
  }

  // Fetch Oficina de ventas
  private fetchAllSalesOffice(): void {
    this.salesOfficeService
      .findToComboBoxGroup(this.form.value.salesOfficeGroupId)
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener oficinas de ventas.", "Cerrar", { duration: 5000 });
        },
      });
  }
  // Métodos para manejar los cambios de filtros
  onTripStatusFilterChange(): void {
    this.pageIndex = 1; // Resetear a la primera página
    if (this.modeTreeTrip === "statusTrip" || this.modeTreeTrip === "functionTrip") {
      this.fetchAllDataForTree();
    } else {
      this.fetchAllWithCount();
    }
  }

  onRouteFunctionFilterChange(): void {
    this.pageIndex = 1;
    if (this.modeTreeTrip === "statusTrip" || this.modeTreeTrip === "functionTrip") {
      this.fetchAllDataForTree();
    } else {
      this.fetchAllWithCount();
    }
  }

  onChangePointTree(mode: "statusTrip" | "functionTrip" | null): void {
    this.modeTreeTrip = mode;
    if (mode === "statusTrip" || mode === "functionTrip") {
      this.fetchAllDataForTree();
    } else {
      this.fetchAllWithCount();
    }
  }
  findAllWithCountTree(): void {
    if (this.modeTreeTrip === "statusTrip" || this.modeTreeTrip === "functionTrip") {
      this.fetchAllDataForTree();
    } else {
      this.fetchAllWithCount();
    }
  }
  // Fetch Grupo de oficina
  private fetchOfficeGroup(): void {
    this.officeGroupService.findToComboBox().subscribe({
      next: (res) => {
        this.officeGroupList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener grupos de oficinas.", "Cerrar", { duration: 5000 });
      },
    });
  }

  // Filter Viajes
  public handleFilterSearch() {
    if (this.modeTreeTrip === "statusTrip" || this.modeTreeTrip === "functionTrip") {
      this.fetchAllDataForTree();
    } else {
      this.fetchAllWithCount();
    }
  }
  statusTrip() {
    this.statusList = TRIP_STATUS_LIST;
  }
  private statusIndicate(id: number): string {
    const statusMap: Record<number, string> = {
      13: "Finalizado",
      12: "Liquidando",
      15: "Doc. Liquidación creado",
      16: "Doc. Liquidación aprobado",
      2: "Abierto",
      3: "Cargando",
      4: "En proceso",
      5: "Cerrado",
    };

    return statusMap[id] ?? "";
  }

  private async transformData(data) {
    const businessId: string[] = [];
    let dataTransform = await Promise.all(
      data.map(async (item) => {
        const idPartner = item.user?.business_partner_id;
        if (idPartner) {
          businessId.push(idPartner);
        }
        const status = this.statusIndicate(item.statusTripId);

        return {
          ...item,
          status,
        };
      })
    );

    this.fetchtAllBusinessPartner(businessId, dataTransform);
  }

  private fetchBussinesPartner(
    id: string
  ): Observable<{ name: string; code: string }> {
    return this.bussinesPartnerService.findById(id).pipe(
      map((res: any) => {
        const data = res?.data;
        return {
          name: data?.name ?? "",
          code: data?.externalKeys?.code ?? "",
        };
      })
    );
  }

  private fetchAllWithCount(): void {
    const hasTripsToFilterOnLoad = this.tripsToFilter.length > 0;
    const search = this.searchService.searchTermSync;

    let dataFilter: IFilters;

    if (hasTripsToFilterOnLoad) {
      // Si hay trips desde URL, SOLO enviar ordersToFilter
      dataFilter = {
        ordersToFilter: this.tripsToFilter.map(id => id.toString())
      };
    } else {
      // Enviar todos los filtros normales del formulario
      dataFilter = {
        charge_start: DateHelper.getStartOfDay(this.form.get("charge_start")?.value),
        charge_end: DateHelper.getEndOfDay(this.form.get("charge_end")?.value) ?? DateHelper.getEndOfDay(this.form.get("charge_start")?.value) ?? null,
        startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
        endTrip: DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ?? null,
        end_startTrip: DateHelper.getStartOfDay(this.form.get("end_startTrip")?.value),
        end_endTrip: DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ?? null,
        companyId: this.form.get("companyId")?.value,
        salesOfficeId: this.form.get("salesOfficeId")?.value,
        salesOfficeGroupId: this.form.get("salesOfficeGroupId")?.value,
        masterUserId: this.form.get("assignedUserId")?.value,
        routeGroupId: this.form.get("routeGroupId")?.value,
        subRouteId: this.form.get("subRouteId")?.value,
        routeTypeId: this.form.get("routeTypeId").value,
        hasUnifiedLoadDocs: this.form.get("hasUnifiedLoadDocs")?.value,
        functionNames: this.selectedRouteFunction.length ? this.selectedRouteFunction : null,
        tripStatuses: this.selectedTripStatuses.length ? this.selectedTripStatuses : null,
        ordersToFilter: null,
      };
    }

    const sortDirection = "ASC";
    this.tripService
      .withCountTrip(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: search?.trim() || undefined, // Evitar pasar string vacío
          sort: null,
          sortDirection: sortDirection,
        },
        dataFilter
      )
      .subscribe((res) => {
        const dataPagination = res.data[0].pageInfo[0];
        this.totalItems = dataPagination?.total;
        this.paginator.length = dataPagination?.total;
        const data = res.data[0].data;
        this.transformData(data);

        // Limpiar tripsToFilter después de usarlo
        if (hasTripsToFilterOnLoad) {
          this.tripsToFilter = [];
        }
      });
  }
  private fetchAllDataForTree(): void {
    this.isLoadingTreedata = true;

    let filter: IFilters = {
      charge_start: DateHelper.getStartOfDay(this.form.get("charge_start")?.value),
      charge_end: DateHelper.getEndOfDay(this.form.get("charge_end")?.value) ?? DateHelper.getEndOfDay(this.form.get("charge_start")?.value) ?? null,
      startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
      endTrip: DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ?? null,
      end_startTrip: DateHelper.getStartOfDay(this.form.get("end_startTrip")?.value),
      end_endTrip: DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ?? null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      salesOfficeGroupId: this.form.get("salesOfficeGroupId")?.value,
      masterUserId: this.form.get("assignedUserId")?.value,
      routeGroupId: this.form.get("routeGroupId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,
      routeTypeId: this.form.get("routeTypeId")?.value,
      hasUnifiedLoadDocs: this.form.get("hasUnifiedLoadDocs")?.value,
      functionNames: this.selectedRouteFunction.length ? this.selectedRouteFunction : null,
      tripStatuses: this.selectedTripStatuses.length ? this.selectedTripStatuses : null,
    };

    this.tripService.findAllForTreeView(filter).subscribe({
      next: (response) => {
        const data = response?.data?.[0]?.data || [];
        this.totalItems = data.length;
        let treeData: TripTreeNode[] = [];
        if (this.modeTreeTrip === 'statusTrip') {
          treeData = this.buildTreeByStatus(data);
        } else if (this.modeTreeTrip === 'functionTrip') {
          treeData = this.buildTreeByFunction(data);
        } else {
          treeData = data.map(item => ({
            ...item,
            level: 0,
            expandable: false
          } as TripTreeNode));
        }
        // Procesar responsable para los datos del árbol
        this.transformDataForTree(treeData);
      },
      error: (error) => {
        this.snackBar.open(error.message || "Error al cargar datos para el modo árbol", "Cerrar", {
          duration: 3000,
        });
        this.isLoadingTreedata = false;
        this.fetchAllWithCount();
      }
    });
  }

  // Método para procesar datos del árbol
  private async transformDataForTree(treeData: TripTreeNode[]): Promise<void> {
    const businessId: string[] = [];
    // Recopilar id de responsable y viajes 
    const extractBusinessIds = (items: TripTreeNode[]) => {
      items.forEach(item => {
        if (item.children) {
          extractBusinessIds(item.children);
        } else if (item.user?.business_partner_id) {
          businessId.push(item.user.business_partner_id);
        }
      });
    };

    extractBusinessIds(treeData);
    // Si es nodo padre, procesa recursivamente sus hijos
    const addStatusToItems = (items: TripTreeNode[]): TripTreeNode[] => {
      return items.map(item => {
        if (item.children) {
          return {
            ...item,
            children: addStatusToItems(item.children)
          };
        } else {
          const status = this.statusIndicate(item.statusTripId);
          return { ...item, status };
        }
      });
    };
    const dataWithStatus = addStatusToItems(treeData);
    await this.fetchBusinessPartnersForTree(businessId, dataWithStatus);
  }

  private async fetchBusinessPartnersForTree(ids: string[], treeData: TripTreeNode[]): Promise<void> {
    if (ids.length === 0) {
      this.dataSourceTreeTrip.data = treeData;
      this.isLoadingTreedata = false;
      return;
    }
    const materialOptions = {
      search: "",
      currentPage: 1,
      limitPerPage: 500,
      sortActive: "name",
    };
    this.bussinesPartnerService
      .findToComboBusinessGroup(materialOptions, ids)
      .subscribe({
        next: (res) => {
          const bussinesList = res?.data ?? [];
          const addBusinessPartnerToItems = (items: TripTreeNode[]): TripTreeNode[] => {
            return items.map(item => {
              if (item.children) {
                return {
                  ...item,
                  children: addBusinessPartnerToItems(item.children)
                };
              } else { // Si es nodo hijo (viaje), busca y agrega su business partner
                const businessPartner = bussinesList.find(
                  bp => bp._id.toString() === item.user?.business_partner_id
                );
                return {
                  ...item,
                  responsible: {
                    code: businessPartner?.externalKeys?.code ?? "",
                    name: businessPartner?.name ?? "",
                    personNumber: businessPartner?.personNumber ?? "",
                    externalKeys: {
                      code: businessPartner?.externalKeys?.code ?? ""
                    }
                  },
                  businessPartner: {
                    code: businessPartner?.externalKeys?.code ?? "",
                    name: businessPartner?.name ?? "",
                  }
                };
              }
            });
          };
          const finalTreeData = addBusinessPartnerToItems(treeData);
          this.dataSourceTreeTrip.data = finalTreeData;
          this.isLoadingTreedata = false;
        },
        error: (err) => {
          this.snackBar.open(err.message || "Error al obtener responsable", "Cerrar", {
            duration: 3000,
          });
          this.dataSourceTreeTrip.data = treeData;
          this.isLoadingTreedata = false;
        }
      });
  }

  private buildTreeByStatus(data: TripAttributes[]): TripTreeNode[] {
    const statusGroups = new Map<StatusEnum, TripTreeNode>();
    data.forEach(trip => {
      const statusId = trip.statusTripId;
      const statusInfo = this.getStatusInfo(statusId);
      if (!statusGroups.has(statusId)) {
        statusGroups.set(statusId, {
          statusInfo,
          children: [],
          isStatusGroup: true,
          expandable: true,
          level: 0
        });
      }

      statusGroups.get(statusId).children.push({
        ...trip,
        isStatusGroup: false,
        expandable: false,
        level: 1
      });
    });

    return Array.from(statusGroups.values());
  }

  private buildTreeByFunction(data: TripAttributes[]): TripTreeNode[] {
    const functionGroups = new Map<string, TripTreeNode>();

    data.forEach(trip => {
      const functionName = trip.subRoute?.function?.name || 'Sin función';
      const functionCode = trip.subRoute?.function?.code || 'N/A';
      const functionInfo = {
        id: trip.subRoute?.function?._id?.toString() || 'unknown',
        name: functionName,
        code: functionCode
      };

      if (!functionGroups.has(functionName)) {
        functionGroups.set(functionName, {
          groupId: `function-${functionName}`, // Usar groupId en lugar de id
          functionInfo,
          children: [],
          isFunctionGroup: true,
          expandable: true,
          level: 0
        });
      }

      functionGroups.get(functionName)!.children!.push({
        ...trip,
        isFunctionGroup: false,
        expandable: false,
        level: 1
      });
    });

    return Array.from(functionGroups.values());
  }
  getGroupIcon(node: TripTreeNode): string {
    if (node.statusInfo) {
      return node.statusInfo.icon;
    }
    return null;

  }

  private getStatusInfo(status: number): { id: number; color: string; info: string; icon: string } {
    switch (status) {
      case 2: return {
        id: 2,
        color: "rgb(65, 106, 218)",
        info: "Abierto",
        icon: "heroicons_solid:check-circle"
      };
      case 3: return {
        id: 3,
        color: "rgb(236, 199, 58)",
        info: "Cargando",
        icon: "heroicons_solid:clock"
      };
      case 4: return {
        id: 4,
        color: "rgb(233, 124, 61)",
        info: "En proceso",
        icon: "heroicons_solid:clock"
      };
      case 5: return {
        id: 5,
        color: "rgb(80, 77, 77)",
        info: "Cerrado",
        icon: "heroicons_solid:x-circle"
      };
      case 12: return {
        id: 12,
        color: "rgb(141, 19, 19)",
        info: "Liquidando",
        icon: "heroicons_solid:x-circle"
      };
      case 13: return {
        id: 13,
        color: "rgb(9, 133, 50)",
        info: "Finalizado",
        icon: "heroicons_solid:check-circle"
      };
      case 15: return {
        id: 15,
        color: "rgb(19, 41, 141)",
        info: "Documento de liquidación creado",
        icon: "heroicons_solid:check-circle"
      };
      case 16: return {
        id: 16,
        color: "rgb(17, 125, 49)",
        info: "Documento de liquidación aprobado",
        icon: "heroicons_solid:check-circle"
      };
      default: return {
        id: 0,
        color: "rgb(156, 163, 175)",
        info: "Estado desconocido",
        icon: "heroicons_solid:question-mark-circle"
      };
    }
  }


  private fechCreateTrip() {
    const loadDateTime = new Date(this.currentCreateTrip.loadDateTime);
    const [hours, minutes] = this.currentCreateTrip.time.split(":");
    loadDateTime.setHours(parseInt(hours), parseInt(minutes));
    this.currentCreateTrip.loadDateTime = loadDateTime;

    const dataToSend = {
      description: this.currentCreateTrip.description,
      loadDateTime: this.currentCreateTrip.loadDateTime
        ? new Date(this.currentCreateTrip.loadDateTime).toISOString()
        : null,
      dateHourStartTeoric: this.currentCreateTrip.dateHourStartTeoric
        ? this.totoUTCISODate(
          new Date(this.currentCreateTrip.dateHourStartTeoric),
          true
        )
        : null,
      dateHourEndTeoric: this.currentCreateTrip.dateHourEndTeoric
        ? this.totoUTCISODate(
          new Date(this.currentCreateTrip.dateHourEndTeoric),
          false
        )
        : null,
      subRouteId: this.currentCreateTrip.subRouteId,
      vehicleId: this.currentCreateTrip.vehicleId,
    };

    this.tripService.createTrip(dataToSend).subscribe({
      next: (res: any) => {
        if (res?.statusCode == "200") {
          this.snackBar.open("Se ha creado un viaje exitosamente", "Cerrar", {
            duration: 3000,
          });
          this.dialogRefAdd.close();
          this.fetchAllWithCount();
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el correo",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  public totoUTCISODate(date: Date, isStartOfDay: boolean): string {
    const localDate = new Date(date);

    if (isStartOfDay) {
      localDate.setHours(0, 0, 0, 0);
    } else {
      localDate.setHours(23, 59, 59, 999);
    }

    return localDate.toISOString();
  }

  // fetchupdateTrip eliminado - ahora manejado por SharedTripEditModalComponent

  private fetchtAllBusinessPartner(ids: string[], data: any): void {
    const materialOptions = {
      search: "",
      currentPage: 1,
      limitPerPage: 500,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.bussinesPartnerService
      .findToComboBusinessGroup(materialOptions, ids)
      .subscribe({
        next: (res: IRequestResult<BusinessPartnerAttributes[]>) => {
          //  this.businessPartnerList = res?.data ?? [];

          const bussinesList = res?.data ?? [];

          const dataWithBussines = data.map((item) => {
            const businessPartner: any = bussinesList.filter(
              (itemBP) => itemBP._id === item.user?.business_partner_id
            );

            return {
              ...item,
              responsible: {
                code: businessPartner[0]?.externalKeys?.code ?? "",
                name: businessPartner[0]?.name ?? "",
                personNumber: businessPartner[0]?.personNumber ?? "",
                externalKeys: {
                  code: businessPartner[0]?.externalKeys?.code ?? ""
                }
              },
              businessPartner: {
                code: businessPartner[0]?.externalKeys?.code ?? "",
                name: businessPartner[0]?.name ?? "",
              },
            };
          });

          this.dataSourceTrip = new MatTableDataSource(dataWithBussines ?? []);
        },
        error: (err) => {
          this.dataSourceTrip = new MatTableDataSource(data ?? []);
          this.snackBar.open(err.error.message || "Error al obtener socios de negocios.", "Cerrar", { duration: 5000 });
        },
      });
  }

  goToTravel(element: TripAttributes) {
    if (element) {
      const queryParams = { tripId: element.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  /**
   * Abre el visor de bitácora para un viaje
   */
  openAuditLog(trip: TripAttributes): void {
    this.auditLogViewerService.open({
      collectionName: AUDIT_LOG_COLLECTIONS.TRIP,
      documentIdentifiers: { _id: (trip as any)._id?.toString() },
    });
  }

  getCreatedTooltip(element: any): string {
    if (!element) return "";

    const createdAt = element.createdAt
      ? new Date(element.createdAt).toLocaleString()
      : "Fecha no disponible";

    const username =
      element.createdBySession?.username ||
      element.createdBy ||
      "Usuario no disponible";

    return `Creado el: ${createdAt}\nPor: ${username}`;
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  getTooltip(element: TripAttributes & { businessPartner?: { code?: string; name?: string } }): string {
    const rutaCode =
      element?.subRoute?.externalKeys?.code ?? element?.subRoute?.model ?? "-";
    const rutaName = element?.subRoute?.name ?? "-";
    const user = element?.user?.user_login?.username ?? "-";

    const bpCode = element?.businessPartner?.code ?? "";
    const bpName = element?.businessPartner?.name ?? "-";

    return [
      `Ruta: ${rutaCode} | ${rutaName}`,
      `Usuario: ${user}`,
      `Responsable: ${bpCode} ${bpName}`.trim(),
    ].join("\n");
  }
}